import React from 'react'
import { ARTICLE_FEATURED_TYPES } from '../../../constants'
import ArticleOverlay from '../../utils/ArticleOverlay'
import ImageWrapper from './styled/ImageWrapper'
import CoveredImage from './CoveredImage'
import Image from './SimpleImage'
import { type OverlayImageProps } from '../Types'

export default (props: OverlayImageProps) => {
  const {
    covered,
    imageClass,
    overlaySize,
    overlayType,
    src
  } = props

  const featuredTypes = [].concat(ARTICLE_FEATURED_TYPES.COMMON).concat(ARTICLE_FEATURED_TYPES.IMAGE)

  return (
    <ImageWrapper>
      {
        featuredTypes.includes(overlayType) &&
        <ArticleOverlay className={`${overlaySize} ${overlayType}`}/>
      }
      {
        covered ? <CoveredImage src={src}/> : <Image className={imageClass} src={src}/>
      }
    </ImageWrapper>
  )
}
